import { StatusChip, StatusChipColor, StatusChipVariant } from "components/StatusChip";
import { prettyPrintEnumValue } from "encamp-shared/src/utils/prettyPrintEnumValue";
import { ImplementationStatus } from "generated-graphql/graphql";

function chipPropsForStatus(status: ImplementationStatus): {
  color: StatusChipColor;
  variant: StatusChipVariant;
} {
  switch (status) {
    case ImplementationStatus.InProgress:
      return { color: "info", variant: "soft" };
    case ImplementationStatus.Blocked:
      return { color: "error", variant: "soft" };
    case ImplementationStatus.Complete:
      return { color: "success", variant: "soft" };
    case ImplementationStatus.NotApplicable:
      return { color: "default", variant: "outlined" };
    case ImplementationStatus.NotStarted:
    default:
      return { color: "default", variant: "soft" };
  }
}

export function ImplementationStatusChip({ status }: { status: ImplementationStatus }) {
  const { color, variant } = chipPropsForStatus(status);
  return (
    <StatusChip
      color={color}
      variant={variant}
      label={prettyPrintEnumValue(status, [], true)}
      // StatusChip's soft "default" fill is alpha(white, 0.08) — invisible on the
      // grid's white surface — so give the neutral chip a visible grey fill.
      sx={{
        flexShrink: 0,
        ...(color === "default" && variant === "soft" ? { bgcolor: "action.selected" } : {}),
      }}
    />
  );
}
